import { render, staticRenderFns } from "./ajsl.vue?vue&type=template&id=2910c3d6&scoped=true&"
import script from "./ajsl.vue?vue&type=script&lang=js&"
export * from "./ajsl.vue?vue&type=script&lang=js&"
import style0 from "./ajsl.vue?vue&type=style&index=0&id=2910c3d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2910c3d6",
  null
  
)

export default component.exports